<template>
    <div>
        <div class="tableDiv">
            <raw-data-table-base 
                :status-info="StatusInfo" 
                :table-id="tableId" 
                :api-info="ApiInfo" 
                :trial-id="TrialId" 
                :progeny-id="ProgenyId" 
                :palm-id="PalmId" 
                :selection-row="selectionRow"
                :export-info="exportInfo"
                @updateParam="$_updateTableParam($event)"
                @reloadTable="reloadTable()"
            >
                <template #TableTitle>
                    <h4>Fatty Acid Data</h4>
                </template>
                <template v-if="isShowTable" #RawTable>
                    <keep-alive>
                        <agrinome-table
                            :key="tableKey"
                            ref="agrinome-table"
                            :api-mode="true"
                            :columns="columns"
                            :selection-row.sync="selectionRow"
                            :http-options="httpOptions"
                            :api-url="apiUrl"
                            :append-params="appendParams"
                            @handle-sort="handleSort"
                            @handle-search="handleSearch"
                            @handle-edit="handleEdit"
                            @confirm-edit="confirmEdit"
                            @handle-delete="handleDelete"
                        />
                    </keep-alive>
                </template>
            </raw-data-table-base>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Router from "vue-router";
import FattyAcidRawVariable from "@/assets/json/fatty-acid-raw-variable.json";
import DataFlag from "@/components/DataFlag";
Vue.use(Router);

export default {
    props: ["PalmId", "TrialId", "ProgenyId"],
    data() {
        return {
            tableCode: "RAW",
            tableId: "#rawFattyAcidTable",

            StatusInfo: null,
            ApiInfo: {
                Table: "FattyAcidData",
                UpdateManyKey: "fattyAcidDataList",
                RepopulateMeanApi: "RepopulateCalculatedData"
            },

            exportInfo: {
                exportUrl: "FattyAcidData/ExportRaw",
                sortValue: "",
                searchValue: ""
            },

            appendParams: {
                PalmId: null,
                TrialId: null,
                ProgenyId: null,
                HasFailChecking: null,
                Status: null,
                RecordDateFrom: null,
                RecordDateTo: null,
                PalmNumber: null
            },

            columns: [
                {
                    name: "id",  
                    label: "ID",
                    sortable: "custom",
                    width: "70",
                    isDisableEdit: true,
                    link: {
                        pageName: "RawFattyAcidDetail",
                        linkId: "id"
                    }
                },
                {
                    name: "palmTrialPalmNumber",
                    label: "Palm No",
                    sortable: "custom",
                    width: "105",
                    link: {
                        pageName: "PalmDetail",
                        linkId: "palmId"
                    }
                },
                {
                    name: "palmTrialPalmId",
                    label: "Palm ID",
                    sortable: "custom",
                    minWidth: "180",
                },
                ...this.getFattyAcidRawVariableInTable(),
                { 
                    name: "recordDate", 
                    label: "Record Date", 
                    width: "170",
                    formatter: this.$_getCreationTimeFormat(),
                    datetime: true,
                    sortable: "custom"
                },
                { 
                    name: "creatorUser.userName", 
                    label: "Created By", 
                    width: "150",
                    sortable: "custom",
                },
                {
                    name: "creationTime",
                    label: "Created At",
                    width: "170",
                    sortable: "custom",
                    formatter: this.$_getCreationTimeFormat(),
                    isDisableEdit: true
                },
                {
                    name: "",
                    label: "Condition Flag",
                    sortable: "custom",
                    width: 85,
                    customVueComponent: this.getDataFlaggedComponent(),
                    customVueComponentParams: {
                        "name": "fattyAcidFlaggedDatas",
                    }
                },
                {
                    name: "status",
                    label: "Status",
                    sortable: "custom",
                    width: "85",
                    editOpts: [
                        { name: "OK", value: "OK" },
                        { name: "R", value: "R" },
                        { name: "KIV", value: "KIV" },
                        { name: "-", value: null },
                    ],
                    editOptId: "status",
                }
            ],
                
            selectionRow: [],
            apiUrl: "/api/services/app/FattyAcidData/GetAll",
            httpOptions: ApiConfig.getHttpOption(),
                
            tableKey: 1,
            isShowTable: false
        };
    },
    computed: {
        sharedAgrinomeTableState: {
            get() { return this.$store.state.isUpdateAgrinomeTable; }
        },
    },
    watch: {
        selectionRow() {
            store.commit("storeSelectionRow", this.selectionRow);
        },
        sharedAgrinomeTableState() {
            if (this.$store.state.isUpdateAgrinomeTable) {
                this.$_reloadAgrinomeTable();
                this.$store.commit("updateAgrinomeTableState", false);
            }
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.appendParams.PalmId = this.PalmId;
            this.appendParams.TrialId = this.TrialId;
            this.appendParams.ProgenyId = this.ProgenyId;
            this.isShowTable = true;
				

            if (!this.PalmId && !this.TrialId && !this.ProgenyId) {
                this.pageLength = 25;
            }
        });
    },
    methods: {
        getDataFlaggedComponent() {
            return DataFlag;
        },
        getFattyAcidRawVariableInTable() {
            // Agrinome Table Test
            return FattyAcidRawVariable.map((item, index) => ({
                name: item.data,
                label: `${item.data} (${item.title})`,
                sortable: "custom",
                width: "85"
            }));
        },
        handleSort(sortValue) {
            this.exportInfo.sortValue = sortValue;
        },
        handleSearch(searchValue) {
            this.exportInfo.searchValue = searchValue;
        },
        handleEdit(index, row) {
            // this.getUsersDropdown();
        },
        confirmEdit(index, row) {
            this.$_confirmTableEdit(index, row, this.ApiInfo.Table);
        },
        handleDelete(index, row) {
            var self = this;
            DialogBus.$emit("open", {
                component: DeleteConfirmation,
                title: "Are you sure",
                props: { apiUrl: self.ApiInfo.Table + "/Delete", data: { id: row.id }, refs: "agrinome-table" },
                onSuccess: function onSuccess() {
                    self.tableKey++;
                }
            });
        },
        reloadTable() {
            this.$_reloadAgrinomeTable();
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Palm/PalmRawData/RawFattyAcidDataTable.vue